@if (messages$ | async; as toastMessages) {
    <div class="toast-notification-container">
        @for (toastMessage of toastMessages; track toastMessage.id) {
            <div class="toast-notification">
                {{ toastMessage.message }}
                <button
                    mat-stroked-button
                    class="hdmui-mx-0 toast-notification__button"
                    (click)="confirmScanning(toastMessage)"
                >
                    {{ '*.accept' | translate }}
                </button>
                <button
                    mat-stroked-button
                    class="hdmui-mx-0 toast-notification__button"
                    (click)="discardScanning(toastMessage.id)"
                >
                    {{ 'IGNORIEREN' | translate }}
                </button>
            </div>
        }
    </div>
}
